import { createAsyncThunk } from '@reduxjs/toolkit';
import api from 'api';
import { PersonalDevelopmentPlan } from 'types/pdp';
import { API_PDP_LIST, API_PDP_OWN } from 'constants/api';
import { storeName as ownPDPStoreName } from 'store/pdp/own/config';

import { RootState } from 'store';
import qs from 'query-string';

export const updateList = createAsyncThunk<
  PersonalDevelopmentPlan[],
  { store: string }
>('pdp/updateList', async ({ store }, { rejectWithValue, getState }) => {
  const state = getState() as RootState;
  const { filters } = state.pdpOwn;

  const url = store === ownPDPStoreName ? API_PDP_OWN : API_PDP_LIST;

  return api.axios
    .get(`${url}?${qs.stringify(filters, { skipNull: true })}`)
    .then((res) => res.data.data)
    .catch((e) => rejectWithValue(e.response?.data));
});
